import axiosInstance from "./AxiosInstance";

export function requestRide(params) {
  const postData = {
    start_point: params.start_point, end_point: params.end_point, description: params.description,
    end_address: params.end_address, start_address: params.start_address,
    phone: params.phone, first_name: params.first_name, order_id: params.order_id,
    time: params.selectedReadyType === 'time' ? new Date(params.time).getTime() / 1000 : null,
  };
  return axiosInstance.post(`/api/rides/${params.id}/make_order`, postData);
}

export function getRide(id) {
  return axiosInstance.get(`/api/rides/${id}`);
}

export function updateRide(id, status) {
  return axiosInstance.put(`/api/rides/${id}/update_status`, { status: status });
}

export function getRoute(startPoint, endPoint, startAddress, endAddress) {
  return axiosInstance.post(`/api/rides/route_price`,
    { start_point: startPoint, end_point: endPoint, start_address: startAddress, end_address: endAddress });
}

export function getPendingRide(id) {
  return axiosInstance.get(`/api/rides/pending_ride${id ? `?taxi_id=${id}` : ''}`);
}